import { Option } from '~/types/CommonTypes';
import i18n from '~modules/i18n';

const { t } = i18n.global;

const createCommissionStatus = (
  color: 'warn' | 'success' | 'danger' | 'info' | 'help',
  content: string,
  tip: string,
) => ({ color, content, tip });

export const COMMISSION_STATUS = {
  PREVIEW: createCommissionStatus(
    'help',
    'COMMISSIONS.STATUS.PREVIEW.LABEL',
    'COMMISSIONS.STATUS.PREVIEW.TIP',
  ),
  AVAILABLE: createCommissionStatus(
    'success',
    'COMMISSIONS.STATUS.AVAILABLE.LABEL',
    'COMMISSIONS.STATUS.AVAILABLE.TIP',
  ),
  PAID: createCommissionStatus(
    'success',
    'COMMISSIONS.STATUS.PAID.LABEL',
    'COMMISSIONS.STATUS.PAID.TIP',
  ),
  EXPIRED: createCommissionStatus(
    'danger',
    'COMMISSIONS.STATUS.EXPIRED.LABEL',
    'COMMISSIONS.STATUS.EXPIRED.TIP',
  ),
  REQUESTED: createCommissionStatus(
    'warn',
    'COMMISSIONS.STATUS.REQUESTED.LABEL',
    'COMMISSIONS.STATUS.REQUESTED.TIP',
  ),
  TO_RECEIVE: createCommissionStatus(
    'warn',
    'COMMISSIONS.STATUS.TO_RECEIVE.LABEL',
    'COMMISSIONS.STATUS.TO_RECEIVE.TIP',
  ),
  CREDITED: createCommissionStatus(
    'success',
    'COMMISSIONS.STATUS.CREDITED.LABEL',
    'COMMISSIONS.STATUS.CREDITED.TIP',
  ),
  REVERSED: createCommissionStatus(
    'danger',
    'COMMISSIONS.STATUS.REVERSED.LABEL',
    'COMMISSIONS.STATUS.REVERSED.TIP',
  ),
  ADVANCED: createCommissionStatus(
    'success',
    'COMMISSIONS.STATUS.ADVANCED.LABEL',
    'COMMISSIONS.STATUS.ADVANCED.TIP',
  ),
};

export const commissionStatusOptions: Option[] = Object.entries(COMMISSION_STATUS).map(
  ([key, value]) => ({
    value: key,
    label: t(value.content),
  }),
);
